// extracted by mini-css-extract-plugin
export default {"block":"AddPhotoInput_block__B1bLX","container":"AddPhotoInput_container__e1cCU","photo":"AddPhotoInput_photo__BuN5g","text":"AddPhotoInput_text__hzh2h"};